import { CardContent as Content } from '@mui/material';
import React from 'react';

function CardContent({ children }) {
  return (
    <Content sx={{
      '&.MuiCardContent-root': {
        padding: 0,
      },
    }}
    >
      {children}
    </Content>
  );
}

export default CardContent;
